import type { ModelComparisonCompareTextBlock } from '@backmarket/http-api/src/api-specs-model-comparison/models/compare-models'

import type { ProductSpecification, Scores } from '../models/product'
import type { Line, TableData } from '../models/productComparison'

export function getSpecificationField(
  productsSpecifications: ProductSpecification[][],
  field: string,
): Line {
  let title = ''
  const values = productsSpecifications.map((productsSpecification) => {
    const productSpecification = productsSpecification.find(
      (i) => i.field === field,
    )
    if (!productSpecification) return null
    if (productSpecification.display) title = productSpecification.display

    return productSpecification.values.map((i) => i.label).join(', ')
  })

  return {
    type: 'text',
    title,
    values,
  }
}

export function getSpecificationFields(
  productsSpecification: ProductSpecification[][],
  fields: string[],
): Line[] {
  return fields.map((field) =>
    getSpecificationField(productsSpecification, field),
  )
}

export function getScoreField(
  scores: Scores[],
  scoreField: keyof Scores,
): Line {
  return {
    type: 'scores',
    values: scores.map((score) => parseFloat(score?.[scoreField] ?? '0')),
  }
}

export function getTextBlockField(
  textBlocks: ModelComparisonCompareTextBlock[],
  id: string,
) {
  const textBlock = textBlocks.find((tb) => tb.section === id)
  if (!textBlock) return undefined

  return {
    format: textBlock?.format,
    value: textBlock?.value,
  }
}
export function cleanTableData(table: TableData[]) {
  for (const tableGroup of table) {
    for (const section of tableGroup.sections) {
      // Filter empty lines
      section.lines = section.lines.filter((line) => {
        if (line.type === 'colors' || line.type === 'tags')
          return line.values?.every((v) => v?.length > 0)
        if (line.type === 'ratings' || line.type === 'scores')
          return line.values?.every((v) => v > 0)
        if (line.type === 'info') return !!line.value

        return line.values?.every((v) => !!v)
      })
    }
    // Filter empty sections
    tableGroup.sections = tableGroup.sections.filter(
      (section) => !!section.lines?.length || !!section.textBlock,
    )
  }

  // Filter empty tableGroups
  return table.filter((tableGroup) => !!tableGroup.sections.length)
}
